import { Header } from './header.model';
import { PageLayout } from './page-layout.model';
import { Logo } from './logo.model';
import { Responsive } from './responsive.model';
import { Footer } from './footer.model';
import { Breadcrumb } from './breadcrumb.model';
import { Row } from '../page-components/row-layout.model';
import { Column } from '../page-components/column-layout.model';
import { Pills } from '../pills.model';

export class Layout {
  SiteLayout: PageLayout = new PageLayout();
  ResponsiveLayout: Responsive = new Responsive();
  HeaderLayout: Header = new Header();
  Logo: Logo = new Logo();
  CustomJS?: string | null;
  CustomCSS?: string | null;
  Row: Row = new Row();
  Column: Column = new Column();
  Footer: Footer = new Footer();
  Breadcrumb: Breadcrumb = new Breadcrumb();
  Pills: Pills = new Pills();
  // UsesTimeBookingModule: boolean = false;
  CssRootVariables: string[] = [];
}
